import {
    clickEvent,
    documentLoadEvent
} from "../../../webpack/modules/events";
import {
    getOuterMenu,
    getOuterMenus,
    showLoader,
    hideLoader
} from "../../../webpack/modules-optimized/outer-menu";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";


documentLoadEvent(function () {
    loadAutoloadOuterMenus();
});

clickEvent('.outer-menu-open', true, (button)  => openOuterMenu(button));

async function openOuterMenu(button)
{
    window.removeEventListener('click', handleOutsideClick);
    let menuId = button.dataset.menu;

    let container = document.querySelector('#outer-menu-container');
    if (!container) return;
    let isDynamic = container.classList.contains('outer-menu-dynamic');
    let menu = container.querySelector(`.outer-menu[data-id="${menuId}"]`);

    if (!menu && isDynamic) {
        container.querySelectorAll('.outer-menu.show').forEach((menuToHide) => menuToHide.classList.remove('show'));
        showLoader();
        slideDown(container);
        let html = await getOuterMenu(menuId);
        if (!html) return;
        hideLoader();
        container.innerHTML += html;
        menu = container.querySelector(`.outer-menu[data-id="${menuId}"]`);
    }

    if (menu.classList.contains('show')) return closeOuterMenu();
    container.querySelectorAll('.outer-menu.show').forEach((menuToHide) => menuToHide.classList.remove('show'));
    menu.classList.add('show');

    slideDown(container);
    setTimeout(() => window.addEventListener('click', handleOutsideClick), 0);
    ga4TrackSimpleEvent(
        {
            event: 'desktop_menu',
            method: 'open'
        }
    );
}

async function closeOuterMenu()
{
    let container = document.querySelector('#outer-menu-container');
    slideUp(container, 200, function() {
        container.querySelectorAll('.outer-menu.show').forEach((menuToHide) => menuToHide.classList.remove('show'));
    });

    window.removeEventListener('click', handleOutsideClick);
    ga4TrackSimpleEvent(
        {
            event: 'desktop_menu',
            method: 'close'
        }
    );
}

function handleOutsideClick(e) {
    detectOutsideClick(e);
}

function detectOutsideClick(event)
{
    if (!document.getElementById('outer-menu-container').contains(event.target)) closeOuterMenu();
}

async function loadAutoloadOuterMenus()
{
    let container = document.querySelector('#outer-menu-container');
    if (!container || !container.classList.contains('autoload-outer-menu')) return;

    let html = await getOuterMenus();
    if (!html) return;

    container.innerHTML = html;
}